import { Display } from ".."
import formatDate from "../formatDate"
import getCurrency from "../getCurrency"

const DataTransaction = ({
	transaction,
	patients,
	providers,
	bankAccounts
}) => {
	const {
		year,
		day,
		month,
		patientId,
		providerId,
		status,
		id,
		createdTs,
		amount,
		serviceId,
		isRollover,
		serviceDate,
		description,
		employer,
		processingTs,
		hraId,
		effectiveDate,
		plan
	} = transaction

	const expenseInfo = {}
	let fundingSource = null
	let dateOfServiceTs = null

	if (transaction.serviceId) {
		const getVal = bankAccounts.get(transaction.serviceId)
		if (!getVal) fundingSource = "deleted"
		else fundingSource = getVal
	} else if (transaction.targetAccount) {
		const getVal = bankAccounts.get(transaction.targetAccount)
		if (!getVal) fundingSource = "deleted"
		else fundingSource = getVal
	} else {
		fundingSource = null
	}

	if (providerId) expenseInfo.provider = providers.get(providerId)
	if (patientId) expenseInfo.patient = patients.get(patientId)
	if (description) expenseInfo.expenseDescription = description

	if (serviceDate) {
		expenseInfo.displayDate = formatDate({
			actions: ["display"],
			options: ["append-timezone"],
			data: serviceDate
		})

		dateOfServiceTs = formatDate({
			data: serviceDate,
			actions: ["ts"],
			options: ["append-timezone"]
		})
	}

	const processingDate = formatDate({
		data: processingTs,
		actions: ["display"],
		defaultReturn: " "
	})

	if (status !== "isSaveForLater") {
		return {
			...transaction,
			plan: plan?.type,
			tableGroup:
				status === "readyToProcess" || status === "notReadyToProcess" ? "pending" : "complete",
			fundingSource,
			expenseInfo,
			dateOfServiceTs,
			tableValues: {
				date: formatDate({ data: createdTs, actions: ["display"] }),
				fundingSource,

				amount: getCurrency({
					amount,
					actions: ["divide"]
				}),
				type: Display.TransactionType({
					amount,
					hraId,
					id,
				}),
				description: Display.TransactionDescription({
					fundingSource,
					serviceId,
					employer,
					isRollover,
					hraId,
					id,
					effectiveDate
				}),
				expenseDescription: expenseInfo.expenseDescription,
				provider: expenseInfo.provider?.tableValues?.name,
				patient: expenseInfo.patient?.tableValues?.name,
				dateOfService: expenseInfo.displayDate,
				status: Display.TransactionStatus({
					value: status,
					id,
					amount
				}),
				processingDate,
				labels: {
					dateOfService: expenseInfo?.displayDate ? "Date Of Service: " : "",
				}
			}
		}
	}
}

export default DataTransaction
